import { useEffect, useState } from 'react';
import growthBook from 'services/growthBook';

/**
 * Waits for the bounded initial feature load before snapshotting checkout flags.
 * @returns {boolean} Whether initial loading settled or was not needed.
 */
const useGrowthBookReady = () => {
  const [ready, setReady] = useState(() => !growthBook.isLoadingFeatures());

  useEffect(() => {
    let mounted = true;
    if (!ready) {
      growthBook.whenFeaturesReady().then(() => {
        if (mounted) setReady(true);
      });
    }
    return () => {
      mounted = false;
    };
  }, [ready]);

  return ready;
};

export default useGrowthBookReady;
